// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const x: number = "Hello"; // No TypeScript error, even though this is invalid.

import { AuthService } from "../services/AuthService";
import { css, htmlArray } from "../helpers/webComponents";
import { Page } from "../enums/Page";
import { GameEventService } from "../services/GameEventService";

const styles: string = css`
 @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');
 
    :host {
        font-family: 'Montserrat', sans-serif;
        width: 100%;
        /* max-width: 768px; */
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        background-color: none;
    }

    .container-login {
        background-color: #fff;
        border-radius: 30px;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.35);
        position: relative;
        overflow: hidden;
        width: 100%;
        max-width: 768px;
        min-height: 480px;
        justify-content: center;
        align-items: center;
    }

    .container-login p {
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.3px;
        margin: 20px 0;
    }

    .container-login a {
        color: #333;
        font-size: 13px;
        text-decoration: none;
        margin: 15px 0 10px;
    }

    .container-login button {
        background-color: rgb(217, 214, 190);
        color: black;
        font-size: 12px;
        padding: 10px 45px;
        border: 1px solid transparent;
        border-radius: 8px;
        font-weight: 600;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        margin-top: 10px;
        cursor: pointer;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.35);
    }

    .container-login button.hidden {
        background-color: transparent;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.35);
    }

    .container-login button:hover {
        background-color: rgb(206, 206, 182);
    }

    .container-login form {
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 0 40px;
        height: 100%;
    }

    .container-login input {
        background-color: #eee;
        border: none;
        margin: 8px 0;
        padding: 10px 15px;
        font-size: 13px;
        border-radius: 8px;
        width: 100%;
        outline: none;
    }

    .form-container-login {
        position: absolute;
        top: 0;
        height: 100%;
        transition: all 0.6s ease-in-out;
    }

    .sign-in {
        left: 0;
        width: 50%;
        z-index: 2;
    }

    .container-login.active .sign-in {
        transform: translateX(100%);
    }

    .sign-up {
        left: 0;
        width: 50%;
        opacity: 0;
        z-index: 1;
    }

    .container-login.active .sign-up {
        transform: translateX(100%);
        opacity: 1;
        z-index: 5;
        animation: move 0.6s;
    }

    @keyframes move {
        0%, 49.99% {
            opacity: 0;
            z-index: 1;
        }
        50%, 100% {
            opacity: 1;
            z-index: 5;
        }
    }

    .toggle-container {
        position: absolute;
        top: 0;
        left: 50%;
        width: 50%;
        height: 100%;
        overflow: hidden;
        transition: all 0.6s ease-in-out;
        border-radius: 150px 0 0 100px;
        z-index: 1000;
    }

    .container-login.active .toggle-container {
        transform: translateX(-100%);
        border-radius: 0 150px 100px 0;
    }

    .toggle {
        background-color: rgb(217, 214, 190);
        height: 100%;
        background: linear-gradient(to right, rgb(217, 214, 190), rgb(206, 206, 182));
        color: black;
        position: relative;
        left: -100%;
        height: 100%;
        width: 200%;
        transform: translateX(0);
        transition: all 0.6s ease-in-out;
    }

    .container-login.active .toggle {
        transform: translateX(50%);
    }

    .toggle-panel {
        position: absolute;
        width: 43%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 0 30px;
        text-align: center;
        top: 0;
        transform: translateX(0);
        transition: all 0.6s ease-in-out;
    }

    .toggle-left {
        transform: translateX(-200%);
    }

    .container-login.active .toggle-left {
        transform: translateX(0);
    }

    .toggle-right {
        right: 0;
        transform: translateX(0);
    }

    .container-login.active .toggle-right {
        transform: translateX(200%);
    }

    #signin-back-to-game,
    #signup-back-to-game {
        position: absolute;
        padding: 10px 20px;
        border: none;
        border-radius: 200px;
        cursor: pointer;
        transition: width 0.8s ease;
        width: 60px;
        height: 40px;
        white-space: nowrap;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    #signin-back-to-game {
        bottom: 20px;
        right: 20px;
    }

    #signup-back-to-game {
        bottom: 20px;
        left: 20px;
    }

    #signin-back-to-game::before,
    #signup-back-to-game::before {
        content: "↩";
        font-size: 18px;
    }

    #signin-back-to-game::after,
    #signup-back-to-game::after {
        content: "Game";
        margin-left: 10px;
        display: block;
        opacity: 0;
        transition: opacity 0.4s ease;
        color: black;
        font-size: 14px;
        width: 0px;
        transition: width 0.8s ease;
    }

    #signin-back-to-game:hover,
    #signup-back-to-game:hover {
        width: 100px;
        transition: width 0.8s ease;
    }

    #signin-back-to-game:hover::after,
    #signup-back-to-game:hover::after {
        opacity: 1;
        width: 100px;
        transition: width 0.8s ease;
    }
`;

export class LoginRegisterComponent extends HTMLElement {
    private _gameEventService: GameEventService = new GameEventService();

    // Inlogvelden
    private signinButton: HTMLButtonElement | null = null;
    private signinUsernameInput: HTMLInputElement | null = null;
    private signinPasswordInput: HTMLInputElement | null = null;

    // Registratievelden
    private signupButton: HTMLButtonElement | null = null;
    private signupUsernameInput: HTMLInputElement | null = null;
    private signupEmailInput: HTMLInputElement | null = null;
    private signupPasswordInput: HTMLInputElement | null = null;
    private signupPasswordConfInput: HTMLInputElement | null = null;

    // Terugknoppen
    private backToGameButtons: HTMLElement[] = [];

    // Toggle-knoppen
    private containerLogin: HTMLElement | null = null;
    private signupHiddenButton: HTMLButtonElement | null = null;
    private signinHiddenButton: HTMLButtonElement | null = null;

    public constructor() {
        super();
        this.attachShadow({ mode: "open" });
    }

    public connectedCallback(): void {
        console.log("LoginRegisterForm connected. Initializing...");
        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) {
            console.warn("Shadow DOM not found. Cannot render login/register form.");
            return;
        }

        // HTML voor de component met htmlArray
        const elements: HTMLElement[] = htmlArray`
            <style>${styles}</style>
            <div class="container-login" id="container-login">
                <div class="form-container-login sign-up">
                    <form id="signup-form">
                        <h1>Account Aanmaken</h1>
                        <input type="text" id="signup-username" placeholder="Gebruikersnaam">
                        <input type="email" id="signup-email" placeholder="E-mail">
                        <input type="password" id="signup-password" placeholder="Wachtwoord">
                        <input type="password" id="signup-password-confirm" placeholder="Wachtwoord bevestigen">
                        <button type="submit" id="signup-button">Registreren</button>
                        <div id="signup-message" class="result-message"></div>
                    </form>
                </div>
                <div class="form-container-login sign-in">
                    <form id="signin-form">
                        <h1>Inloggen</h1>
                        <input type="text" id="signin-username" placeholder="Gebruikersnaam">
                        <input type="password" id="signin-password" placeholder="Wachtwoord">
                        <button id="signin-button">Inloggen</button>
                        <div id="signin-message" class="result-message"></div>
                    </form>
                </div>
                <div class="toggle-container">
                    <div class="toggle">
                        <div class="toggle-panel toggle-left">
                            <button id="signup-back-to-game"></button>
                            <h1>Geregistreerd?</h1>
                            <p>Voer je inlog gegevens in om verder te gaan</p>
                            <button class="hidden" id="signin-hidden-button">Inloggen</button>
                        </div>
                        <div class="toggle-panel toggle-right">
                            <button id="signin-back-to-game"></button>
                            <h1>Welkom!</h1>
                            <p>Registreer je om je highscore op te slaan</p>
                            <button class="hidden" id="signup-hidden-button">Registreren</button>
                        </div>
                    </div>
                </div>
            </div>
        `;

        // Clearen van de shadowRoot en toevoegen van de gegenereerde HTML
        this.shadowRoot.innerHTML = "";
        this.shadowRoot.append(...elements);

        // Initialiseren van de elementen
        this.initializeElements();

        // Belangrijk: Auth toggle initialiseren ná `initializeElements`
        this.initializeAuthToggle();

        // Event listeners toevoegen
        this.addEventListeners();
    }

    private initializeElements(): void {
        if (!this.shadowRoot) return;

        // Haal de toggle-elementen op en sla ze op in de klasse-eigenschappen
        this.containerLogin = this.shadowRoot.querySelector("#container-login");
        this.signupHiddenButton = this.shadowRoot.querySelector("#signup-hidden-button");
        this.signinHiddenButton = this.shadowRoot.querySelector("#signin-hidden-button");

        // Haal de rest van de elementen op (zoals je al had)
        this.signinButton = this.shadowRoot.querySelector("#signin-button");
        this.signinUsernameInput = this.shadowRoot.querySelector("#signin-username");
        this.signinPasswordInput = this.shadowRoot.querySelector("#signin-password");

        this.signupButton = this.shadowRoot.querySelector("#signup-button");
        this.signupUsernameInput = this.shadowRoot.querySelector("#signup-username");
        this.signupEmailInput = this.shadowRoot.querySelector("#signup-email");
        this.signupPasswordInput = this.shadowRoot.querySelector("#signup-password");
        this.signupPasswordConfInput = this.shadowRoot.querySelector("#signup-password-confirm");

        this.backToGameButtons = Array.from(this.shadowRoot.querySelectorAll("#signin-back-to-game, #signup-back-to-game"));
    }

    private initializeAuthToggle(): void {
        if (!this.signupHiddenButton || !this.signinHiddenButton || !this.containerLogin) {
            console.warn("Toggle elementen niet gevonden.");
            return;
        }

        this.signupHiddenButton.addEventListener("click", () => {
            this.containerLogin?.classList.add("active");
        });

        this.signinHiddenButton.addEventListener("click", () => {
            this.containerLogin?.classList.remove("active");
        });
    }

    private addEventListeners(): void {
        // Event listeners voor de "terug naar game" knoppen
        this.backToGameButtons.forEach(button => {
            button.addEventListener("click", () => {
                this._gameEventService.switchPage(Page.Canvas);
            });
        });

        // Event listener voor inloggen
        if (this.signinButton && this.signinUsernameInput && this.signinPasswordInput) {
            this.signinButton.addEventListener("click", async (event: MouseEvent) => {
                event.preventDefault();
                const username: string = this.signinUsernameInput!.value.trim();
                const password: string = this.signinPasswordInput!.value.trim();
                const messageContainer: HTMLElement | null = this.shadowRoot!.querySelector("#signin-message");

                if (username && password) {
                    const authService: AuthService = new AuthService();
                    const result: {
                        success: boolean;
                        message?: string;
                    } = await authService.loginUser(username, password);

                    this.displayMessage(result.success ? "Succesvol ingelogd!" : result.message || "Ongeldige inloggegevens!", result.success, messageContainer);

                    this.signinUsernameInput!.value = "";
                    this.signinPasswordInput!.value = "";

                    if (result.success) {
                        setTimeout(() => {
                            this._gameEventService.switchPage(Page.Canvas);
                        }, 1000);
                    }
                }
                else {
                    this.displayMessage("Vul alle velden in.", false, messageContainer);
                }
            });
        }

        // Event listener voor registratie
        if (this.signupButton && this.signupUsernameInput && this.signupEmailInput && this.signupPasswordInput && this.signupPasswordConfInput) {
            this.signupButton.addEventListener("click", async (event: MouseEvent) => {
                event.preventDefault();
                const username: string = this.signupUsernameInput!.value.trim();
                const email: string = this.signupEmailInput!.value.trim();
                const password: string = this.signupPasswordInput!.value.trim();
                const passwordConf: string = this.signupPasswordConfInput!.value.trim();
                const messageContainer: HTMLElement | null = this.shadowRoot!.querySelector("#signup-message");

                const authService: AuthService = new AuthService();

                if (!username || !email || !password || !passwordConf) {
                    this.displayMessage("Vul alle velden in.", false, messageContainer);
                    return;
                }

                if (password !== passwordConf) {
                    this.displayMessage("Wachtwoorden komen niet overeen!", false, messageContainer);
                    return;
                }

                const usernameError: string = this.validateUsername(username);
                if (usernameError) {
                    this.displayMessage(usernameError, false, messageContainer);
                    return;
                }

                const usernameExists: boolean = await authService.checkUsernameExists(username);
                if (usernameExists) {
                    this.displayMessage("Deze gebruikersnaam is al in gebruik!", false, messageContainer);
                    return;
                }

                const emailError: string = this.validateEmail(email);
                if (emailError) {
                    this.displayMessage(emailError, false, messageContainer);
                    return;
                }

                const emailExists: boolean = await authService.checkEmailExists(email);
                if (emailExists) {
                    this.displayMessage("Dit e-mailadres is al in gebruik!", false, messageContainer);
                    return;
                }

                const passwordError: string = this.validatePassword(password);
                if (passwordError) {
                    this.displayMessage(passwordError, false, messageContainer);
                    return;
                }

                const success: boolean = await authService.registerUser(username, email, password);

                this.displayMessage(success ? "Registratie succesvol!" : "Registratie mislukt!", success, messageContainer);

                if (success) {
                    localStorage.removeItem("playerSessionId");
                    this.signupUsernameInput!.value = "";
                    this.signupEmailInput!.value = "";
                    this.signupPasswordInput!.value = "";
                    this.signupPasswordConfInput!.value = "";

                    setTimeout(() => {
                        this.shadowRoot!.querySelector("#container-login")?.classList.remove("active");
                    }, 1500);
                }
            });
        }
    }

    private displayMessage(message: string, isSuccess: boolean, messageContainer: HTMLElement | null): void {
        if (messageContainer) {
            messageContainer.innerHTML = "";
            const messageElement: HTMLParagraphElement = document.createElement("p");
            messageElement.textContent = message;
            messageElement.style.color = isSuccess ? "green" : "red";
            messageElement.style.marginTop = "10px";
            messageContainer.appendChild(messageElement);
        }
    }

    private validatePassword(password: string): string {
        const requirements: string[] = [];
        const minLength: number = 8;

        if (password.length < minLength) {
            requirements.push(`${minLength} tekens. Huidig (${password.length})`);
        }
        if (!/[A-Z]/.test(password)) {
            requirements.push("één hoofdletter");
        }
        if (!/[a-z]/.test(password)) {
            requirements.push("één kleine letter");
        }
        if (!/\d/.test(password)) {
            requirements.push("één cijfer");
        }
        if (!/[@$!%*?&.]/.test(password)) {
            requirements.push("één speciaal teken (bijv. @$!%*?&)");
        }

        return requirements.length > 0
            ? `Wachtwoord moet minimaal bevatten:\n - ${requirements.join("\n - ")}`
            : "";
    }

    private validateEmail(email: string): string {
        const emailRegex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return !emailRegex.test(email)
            ? "Ongeldig e-mailadres. Gebruik een correct formaat zoals 'voorbeeld@domein.com'."
            : "";
    }

    private validateUsername(username: string): string {
        const usernameRegex: RegExp = /^[a-zA-Z0-9_]{3,}$/;
        return !usernameRegex.test(username)
            ? "Gebruikersnaam moet minstens 3 tekens lang zijn en mag alleen letters, cijfers en '_' bevatten."
            : "";
    }
}
